/**
=========================================================
* Argon Dashboard 2 PRO MUI - v3.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-mui
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props.
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import FullCalendar from "@fullcalendar/react";

// @fullcalendar components
import timeGridPlugin from "@fullcalendar/timegrid";

// @mui material components
import Card from "@mui/material/Card";
import PropTypes from "prop-types";

// Argon Dashboard 2 PRO MUI components
import BusinessCalendar from "0.Mine/0.Components/BusinessCard/EventCalendar/Container/BusinessCalendar";
import { BusinessCalendarUI } from "0.Mine/0.Components/BusinessCard/EventCalendar/UI/FullCalendar";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";

// Argon Dashboard 2 PRO MUI contexts
import { useArgonController } from "context";

// Custom styles for Calendar
import CalendarRoot from "examples/Calendar/CalendarRoot";

function BusinessEventCalendar({ header, ...rest }) {
  const [controller] = useArgonController();
  const { darkMode } = controller;
  const validClassNames = [
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "light",
    "dark",
  ];

  return (
    <Card sx={{ height: "100%", boxShadow: "unset!important" }}>
      <ArgonBox pt={2} px={2} lineHeight={1}>
        {header.title ? (
          <ArgonTypography variant="h6" fontWeight="medium" textTransform="capitalize">
            {header.title}
          </ArgonTypography>
        ) : null}
        {header.date ? (
          <ArgonTypography component="p" variant="button" color="text" fontWeight="medium">
            {header.date}
          </ArgonTypography>
        ) : null}
      </ArgonBox>
      <CalendarRoot p={2} ownerState={{ darkMode }}>
        <BusinessCalendar />
      </CalendarRoot>
    </Card>
  );
}

// Setting default values for the props of Calendar
BusinessEventCalendar.defaultProps = {
  header: {
    title: "",
    date: "",
  },
};

// Typechecking props for the Calendar
BusinessEventCalendar.propTypes = {
  header: PropTypes.shape({
    title: PropTypes.string,
    date: PropTypes.string,
  }),
};

export default BusinessEventCalendar;
